import React from 'react';
import { Grid, Button, Dropdown, Form } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';

const AssignUserMF = ({
  onChangeOfMF,
  onChangeOfUser,
  userLoading,
  mfLoading,
  submitting,
  handleSubmit,
  mfList,
  userList
}) => (
  <Grid centered style={{ marginTop: '0px', padding: '10vh' }}>
    <Helmet>
      <title>Assign Manufacturer to User </title>
    </Helmet>
    <Grid.Row centered>
      <Grid.Column width={4}>
        <h2
          style={{
            fontWeight: 400,
            marginBottom: '1em',
            border: '1px solid #555',
            textAlign: 'center',
            color: '#555',
            padding: '0.5em'
          }}
        >
          Assign Manufacturer to User
        </h2>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={8}>
        <Form>
          <Form.Field required>
            <label>Select User</label>
            <Dropdown
              disabled={userLoading || submitting}
              onChange={onChangeOfUser}
              selection
              search
              options={userList || []}
            />
          </Form.Field>
          <Form.Field>
            <label>Select Manufacturer(s)</label>
            <Dropdown
              disabled={mfLoading || submitting}
              onChange={onChangeOfMF}
              selection
              options={mfList}
              multiple
            />
          </Form.Field>
          <Form.Field />
          <Button
            loading={submitting}
            onClick={handleSubmit}
            basic
            color="blue"
            style={{ float: 'right' }}
          >
            Assign Manufacturer(s)
          </Button>
        </Form>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default AssignUserMF;



// WEBPACK FOOTER //
// ./src/Modules/UsersAssignMF/component.jsx